module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27601",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7231",
      "conversations-error-reporting": "static-1.8463",
      "conversations-internal-pub-sub": "static-1.15537",
      "conversations-internal-schema": "static-1.12198",
      "conversations-message-history": "static-1.11286",
      "conversations-test-sdk": "static-1.9981",
      "conversations-visitor-experience-components": "static-1.20964",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5059",
      "hs-test-utils": "static-1.7478",
      "hubspot-dlb": "static-2.1739",
      "HubStyleTokens": "static-2.11002",
      "I18n": "static-7.1488",
      "jasmine-immutable": "static-1.2499",
      "jasmine-runner": "static-1.5948",
      "quartz": "static-1.6332",
      "react-dlb": "static-1.65",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.4096",
      "viral-links-lib": "static-1.6489",
      "visitor-ui-component-library": "static-1.5695",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.4158",
      "atom": "static-1.4662",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4310",
      "conversations-infrastructure": "static-1.8485",
      "conversations-prop-types": "static-1.6910",
      "conversations-visibility-tools": "static-1.5272",
      "conversations-visitor-message-history": "static-1.19701",
      "cssUtils": "static-1.640",
      "enviro": "static-4.345",
      "flux-actions": "static-1.291",
      "foundations-components": "static-1.7071",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3757",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9220",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16196",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4925",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3939",
      "sanitize-text": "static-1.7686",
      "signup-constants": "static-1.17898",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.479",
      "usage-tracker": "static-1.6905",
      "usage-tracker-core": "static-1.6755",
      "usage-tracker-multi": "static-1.5319",
      "usage-tracker-public": "static-1.6716",
      "visitor-ui-component-library-icons": "static-1.5506",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3022",
      "moment": "static-3.26",
      "quartz-config": "static-1.110",
      "quartz-core": "static-1.5551",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4356",
      "foundations-theming": "static-1.3896",
      "UIComponents": "static-3.7949",
      "cv-backend-services": "static-1.1397",
      "immutable-less": "static-1.4090",
      "conversations-skeleton-state": "static-1.6836",
      "crm-events-viz-core": "static-1.31778",
      "customer-agent-discovery-components-lib": "static-1.1822",
      "icons": "static-2.599",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4188",
      "tanstack-virtual": "static-1.20",
      "ui-images": "static-2.1001",
      "permission-components": "static-1.4849",
      "react-virtualized": "static-2.87",
      "HeadJS": "static-2.649",
      "framer-motion": "static-1.58",
      "hs-test-utils-bend-plugin": "static-1.2589",
      "msw": "static-1.39",
      "testing-library": "static-1.140",
      "i18n-data": "static-1.212",
      "moment-timezone": "static-5.73",
      "jasmine": "static-4.3807",
      "signup-ui-url-generator": "static-2.7585",
      "HubStyle": "static-2.11310",
      "sassPrefix": "static-1.146",
      "bend-plugin-foundations-components": "static-1.3340",
      "floating-ui": "static-1.46",
      "foundations-theming-specialty": "static-1.1612",
      "hs-story-utils": "static-1.8898",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.772",
      "ui-fonts": "static-1.335",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3515",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5322",
      "bender-build-tools": "static-1.2674",
      "dispatcher": "static-1.126",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.727",
      "hub-http-shared-msw-handlers": "static-1.8901",
      "hubspotter-http": "static-1.4219",
      "hubspotter-http-shared-msw-handlers": "static-1.8899",
      "mobile-manifest-mixins": "static-1.422",
      "bend-plugin-foundations-theming": "static-1.2379",
      "foundations-theming-base": "static-1.2881",
      "stylex": "static-1.22",
      "ts-schema": "static-1.3692",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2035",
      "content-assistance-lib": "static-1.7151",
      "crm-component-utils": "static-1.37892",
      "crm-display-components": "static-1.23642",
      "crm-fe-perf": "static-1.22464",
      "crm-links": "static-1.5725",
      "crm-message-bus": "static-1.41748",
      "crm-search-service-types": "static-1.779",
      "crm-source-interpretation-lib": "static-1.4802",
      "customer-data-communicator": "static-1.44284",
      "customer-data-email": "static-1.17186",
      "customer-data-filters-ui": "static-1.38079",
      "customer-data-objects": "static-1.7177",
      "customer-data-objects-ui-components": "static-1.12528",
      "customer-data-properties": "static-1.50072",
      "customer-data-rte": "static-1.31878",
      "customer-data-ui-utilities": "static-1.9299",
      "data-fetching-client": "static-1.9207",
      "draft-plugins": "static-2.20816",
      "file-manager-components": "static-1.22194",
      "FileManagerCore": "static-1.37693",
      "framework-data-schema-resolvers": "static-1.6434",
      "frontend-preferences-client": "static-1.7488",
      "hubspot-apollo-client": "static-1.4346",
      "hubspot-prosemirror": "static-1.16987",
      "object-comments-thread-lib": "static-1.9530",
      "reference-resolvers-lite": "static-1.7580",
      "ui-addon-upgrades": "static-9.17215",
      "universal-associations-select": "static-1.10513",
      "ai-components-ui-library": "static-1.7694",
      "final-form": "static-1.60",
      "graphql": "static-1.72",
      "superstore": "static-1.4268",
      "ui-addon-video-player": "static-1.8295",
      "ui-coaching-tips": "static-1.27297",
      "card-properties-lib": "static-1.42896",
      "crm-actions": "static-1.5728",
      "crm-cards-data": "static-1.726",
      "crm-cards-sdk": "static-1.42259",
      "customer-data-properties-shared-msw-handlers": "static-1.8228",
      "customer-data-property-utils": "static-1.7526",
      "customer-data-tracking": "static-1.6427",
      "usage-tracker-container": "static-1.6895",
      "framework-data-table": "static-2.10859",
      "location-customization-utils-lib": "static-1.7881",
      "calling-error-reporting": "static-1.30848",
      "calling-internal-common": "static-1.30842",
      "calling-usage-tracker": "static-1.6107",
      "crm_data": "static-4.90490",
      "crm_schema": "static-3.90529",
      "crm-legacy-global-containers": "static-1.23328",
      "customer-data-content": "static-1.26390",
      "draft-content-plugins": "static-1.27251",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23238",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22948",
      "EmailSignatureEditor": "static-1.23508",
      "FileManagerLib": "static-1.37834",
      "hubspot-prosemirror-plugins": "static-1.16979",
      "integration-settings-components": "static-1.14034",
      "integrations-lib": "static-1.14704",
      "integrations-tracking-lib": "static-1.5160",
      "native-integrations-shared-strings": "static-1.7354",
      "nav-meta": "static-1.28295",
      "onboarding-scopes": "static-1.6013",
      "outreach-assistant-email-generation": "static-1.5332",
      "property-translator": "static-1.4898",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36476",
      "react-colorpicker": "static-2.9756",
      "react-dnd-compat": "static-1.4195",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7740",
      "rich-text-lib": "static-1.18978",
      "sales-email-signature-service-client": "static-1.3420",
      "sequences-lib": "static-1.7326",
      "timezone-utils": "static-2.4724",
      "ui-addon-i18n": "static-1.10573",
      "ui-addon-iframeable": "static-1.8470",
      "ui-business-units-lib": "static-1.8480",
      "ui-gdpr-components": "static-1.9794",
      "ui-shepherd-react": "static-3.9621",
      "user-context": "static-1.4661",
      "whatsapp-sending-lib": "static-1.4317",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4224",
      "salesImages": "static-1.515",
      "customer-data-filters-ui-msw-helpers": "static-1.20513",
      "customer-data-reference-ui-components": "static-1.12593",
      "FormUrlGenerator": "static-2.4203",
      "framework-builder-read-service-client": "static-1.3563",
      "framework-data-schema-quick-fetch": "static-1.6339",
      "inbound-db-meta-service-client": "static-1.3248",
      "inbound-db-properties-service-client": "static-1.3481",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.540",
      "onboarding-tours": "static-1.15949",
      "reporting-datasets-permissions-lib": "static-1.12320",
      "SharedI18nStrings": "static-1.177",
      "ui-addon-teams": "static-1.20919",
      "calling-global-api": "static-1.62953",
      "calling-lifecycle-internal": "static-1.64335",
      "calling-lifecycle-messages": "static-1.56629",
      "commerce-products-lib": "static-1.8131",
      "conditional-properties-service-client": "static-1.3422",
      "external-options-client-types": "static-1.3641",
      "google-libphonenumber": "static-1.27",
      "inbound-db-associations-writes-service-client": "static-1.2746",
      "inbounddb-objects-service-types": "static-1.3728",
      "meetings-icalendar-utils-lib": "static-1.105",
      "multi-currency-client-types": "static-1.3258",
      "object-builder-ui-client": "static-1.47240",
      "pipeline-validation-client-types": "static-1.3482",
      "property-value-citations": "static-1.686",
      "smart-property-lib": "static-1.5030",
      "tiered-pricing": "static-1.470",
      "ui-addon-form-validation": "static-1.10529",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3629",
      "video-components-external": "static-1.9899",
      "video-data-lib": "static-1.33557",
      "audio-components": "static-1.5318",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35345",
      "video-components": "static-1.11902",
      "video-embed": "static-1.34391",
      "batch-promise": "static-1.1115",
      "crm-pipelines-api-client-types": "static-1.3616",
      "persist-promise": "static-1.3272",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24065",
      "knowledge-content-types": "static-1.8162",
      "payment-link-components": "static-1.22360",
      "ui-addon-emoji-picker": "static-1.9427",
      "call-summary": "static-1.37644",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9047",
      "feature-store-service-types": "static-1.4118",
      "growth-monetization-service-types": "static-1.4125",
      "merchandise-lib": "static-1.248",
      "purchase-motions-components": "static-1.5062",
      "self-service-api": "static-1.9746",
      "upgrade-management-service-types": "static-1.4109",
      "chatspot-client-types": "static-1.10221",
      "chatspot-core": "static-1.19497",
      "ContentUtils": "static-1.66968",
      "copilot-toolkit": "static-1.9887",
      "growth-onboarding-feedback-components": "static-1.6062",
      "customer-data-sidebar": "static-2.44752",
      "enrichment-properties-lib": "static-1.14148",
      "customer-data-associations": "static-1.6795",
      "deal-intel-decorators": "static-1.552",
      "reporting-data": "static-1.65607",
      "ui-addon-draggable": "static-3.4333",
      "crm-record-cards-service-types": "static-1.3255",
      "crm_universal": "static-1.21348",
      "SalesContentIndexUI": "static-3.8454",
      "signup-ui-lego-core": "static-1.19908",
      "content-embed-lib": "static-1.6913",
      "data-model-builder-lib": "static-1.10827",
      "remote-ui": "static-1.55",
      "ui-components-test-utils": "static-1.5140",
      "ui-extensions-remote-renderer": "static-1.15855",
      "universal-page-editor-lib": "static-1.2558",
      "integrations-error-boundary-lib": "static-1.12119",
      "laboratory-lib": "static-3.6665",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9957",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8391",
      "messaging-types-lib": "static-1.44662",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15650",
      "sequences-client-types-lib": "static-1.7183",
      "foundations-components-test-utils": "static-1.4555",
      "magpie-lib": "static-1.5135",
      "navigation-messaging": "static-1.5985",
      "getting-started-shared-tasks": "static-1.17249",
      "getting-started-shared-tasks-store": "static-1.16367",
      "whatsapp-management-lib": "static-1.7476",
      "growth-data-modal": "static-1.4884",
      "growth-onboarding-confetti": "static-1.2580",
      "growth-onboarding-next-action-utils": "static-1.958",
      "navigation-components": "static-1.16658",
      "onboarding-tours-client": "static-1.4163",
      "onboarding-tours-utils": "static-1.15",
      "ui-shepherd-tracker": "static-1.7002",
      "shared-worker-versioning": "static-1.10590",
      "calling-orchestration-shared-library": "static-1.34132",
      "products-iframe-lib": "static-1.6707",
      "products-ui-components-shared-msw-handlers": "static-1.9283",
      "breeze-intelligence-kit": "static-1.4978",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8984",
      "fsm": "static-1.3216",
      "policy-lib": "static-1.6303",
      "react-tinymce": "static-1.53974",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53100",
      "tinymce-plugins": "static-1.56214",
      "tinymce-themes": "static-1.55070",
      "content-media-composition-data-lib": "static-1.10388",
      "content-media-compositions": "static-2.14395",
      "idb-keyval": "static-1.34",
      "magpie-types": "static-1.4595",
      "media-bridge-lib": "static-1.18188",
      "content-icons-ui": "static-1.2055",
      "social-insights-client-types": "static-1.20779",
      "outpost": "static-1.3815",
      "commerce-analytics-service-client": "static-1.3182",
      "ui-addon-opt": "static-4.7970",
      "commerce-tours-lib": "static-1.5347",
      "growth-onboarding-reliability": "static-1.4660",
      "sales-checkout-service-client": "static-1.3194",
      "ai-addon-copilot-preview": "static-1.6906",
      "calling-cross-tab-library": "static-1.18814",
      "calling-lifecycle-usage-tracker": "static-1.7516",
      "wootric-nps": "static-1.6438",
      "nav-client-types": "static-1.1808",
      "purchase-motions-api": "static-1.5064",
      "trials-service-types": "static-1.3526",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4225",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2527",
      "card-payment-highlight-lib": "static-1.35889",
      "card-subscription-highlight-lib": "static-1.38278",
      "commerce-billing-lib": "static-1.17837",
      "commerce-contract-lib": "static-1.10395",
      "crm_components": "static-3.90490",
      "invoices-highlight-card-lib": "static-1.53311",
      "orders-highlight-card-lib": "static-1.20375",
      "products-highlight-card-lib": "static-1.16415",
      "project-storage": "static-1.4196",
      "quotes-highlight-card-lib": "static-1.70389",
      "usage-based-billing-components-lib": "static-1.7401",
      "deal-intel-utils": "static-1.556",
      "reporting-client-types": "static-1.2296",
      "react-flip-move": "static-1.60",
      "FireAlarmUi": "static-1.4124",
      "sales-templates-service-types-lib": "static-1.3779",
      "ui-asset-management-lib": "static-1.10379",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9004",
      "collaboration-sidebar": "static-1.56589",
      "conditional-property-settings-modal": "static-1.11431",
      "data-model-commons-lib": "static-1.11365",
      "feedback-loader": "static-1.28359",
      "html-to-image": "static-1.44",
      "object-definition-builder-lib": "static-1.6568",
      "property-management-iframe": "static-1.11496",
      "reactflow": "static-1.51",
      "simple-data-table": "static-1.1513",
      "used-in-list-lib": "static-1.6423",
      "visual-association": "static-1.5351",
      "highcharts": "static-8.94",
      "reporting-visualizations": "static-1.57684",
      "ui-extensibility-client-types": "static-1.3549",
      "automation-platform-service-types": "static-1.2367",
      "ContentData": "static-1.67043",
      "email-portal-health-service-types": "static-1.556",
      "marketing-email-service-types": "static-1.1657",
      "reactive-lib": "static-1.265",
      "content-whatsapp-service-types": "static-1.102",
      "marketing-platform-lib": "static-1.6290",
      "short-messages-app-service-client": "static-1.3580",
      "ui-tool-access": "static-1.9655",
      "calling-orchestration-schema": "static-1.34357",
      "sales-views-client-types": "static-1.3811",
      "trellis-story-utils": "static-1.4053",
      "storybook-react": "static-1.22",
      "hub-http-contrib": "static-1.2634",
      "interframe": "static-3.4274",
      "tinymce-data": "static-1.39185",
      "ui-addon-sales-email": "static-1.4734",
      "codemirror": "static-5.85",
      "layout-dnd-components": "static-1.11604",
      "layout-dnd-utils": "static-1.10579",
      "react-codemirror": "static-1.10174",
      "ui-brand-identity-lib": "static-1.12868",
      "NamespacedHubStyle": "static-2.8704",
      "hls.js": "static-1.29",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8620",
      "ai-settings-ui-library": "static-1.6980",
      "chirp-fetch": "static-1.1470",
      "copilot-plugins": "static-1.9860",
      "eligibility-engine-service-types": "static-1.2807",
      "commerce-shared-components-lib": "static-1.17324",
      "commerce-subscription-lib": "static-1.35855",
      "commerce-tools-ui-lib": "static-1.9270",
      "usage-tracker-session-replay": "static-1.4591",
      "utility-belt": "static-1.2014",
      "payments-enrollment-embed-lib": "static-1.21210",
      "quotes-ui-lib": "static-1.79107",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6263",
      "invoices-ui-lib": "static-1.53327",
      "commerce-products-api": "static-1.1536",
      "SafeStorage": "static-1.3871",
      "invoices-iframe-lib": "static-1.55385",
      "quotes-modal-lib": "static-1.101064",
      "reporting-ui-components": "static-2.62881",
      "subscription-experience-data-types": "static-1.14175",
      "association-translator": "static-1.2678",
      "crm-settings-header-lib": "static-1.7769",
      "settings-ui-nav": "static-2.9721",
      "chatspot-widget-iframe": "static-1.19489",
      "collaboration-sidebar-common": "static-1.1385",
      "crm-properties-common-lib": "static-1.5327",
      "ui-addon-draggable-compat": "static-2.3824",
      "property-management-common": "static-1.3783",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14425",
      "advanced-menus-lib": "static-1.11440",
      "ExportDialog": "static-6.9968",
      "ui-memberships-settings-lib": "static-1.32760",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8904",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.12886",
      "highlight.js": "static-1.69",
      "reporting-action-components": "static-1.40089",
      "ui-addon-react-router-dom": "static-1.9113",
      "growth-onboarding-empty-states": "static-1.5052",
      "InboxConnectUtils": "static-4.13657",
      "payments-post-enroll-local-storage-lib": "static-1.4561",
      "qrcode-generator": "static-1.59",
      "amplitude-session-replay-browser": "static-1.50",
      "marketplace-ui-apps-core": "static-1.16838",
      "stripe-embedded-components": "static-1.6761",
      "products-ui-components": "static-1.38650",
      "totals-ui-components": "static-1.22357",
      "reporting-plugins": "static-1.9592",
      "reporting-reports": "static-1.65287",
      "reporting-snowflake": "static-1.54227",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14424",
      "simple-menus-lib": "static-1.15941",
      "academy-common-lib": "static-1.12346",
      "dashboard-lib": "static-1.79718",
      "share-with-third-party-component-lib": "static-1.8222",
      "developer-experience-shared-components": "static-1.9940",
      "marketplace-ui-client-types": "static-1.15711",
      "marketplace-ui-common": "static-1.18304",
      "ui-addon-integrations-directory-panel": "static-2.7547",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.270",
      "property-description-translator": "static-1.3345",
      "commerce-totals-service-types": "static-1.3372",
      "campaign-roi-lib": "static-1.7604",
      "academy-service-client": "static-1.3213",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3466",
      "oauth-service-types": "static-1.3777",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27601",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7231",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8463",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15537",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12198",
      "conversations-message-history": "/conversations-message-history/static-1.11286",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9981",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20964",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5059",
      "hs-test-utils": "/hs-test-utils/static-1.7478",
      "hubspot-dlb": "/hubspot-dlb/static-2.1739",
      "HubStyleTokens": "/HubStyleTokens/static-2.11002",
      "I18n": "/I18n/static-7.1488",
      "jasmine-immutable": "/jasmine-immutable/static-1.2499",
      "jasmine-runner": "/jasmine-runner/static-1.5948",
      "quartz": "/quartz/static-1.6332",
      "react-dlb": "/react-dlb/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4096",
      "viral-links-lib": "/viral-links-lib/static-1.6489",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5695",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4158",
      "atom": "/atom/static-1.4662",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4310",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8485",
      "conversations-prop-types": "/conversations-prop-types/static-1.6910",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5272",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19701",
      "cssUtils": "/cssUtils/static-1.640",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.291",
      "foundations-components": "/foundations-components/static-1.7071",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3757",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9220",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16196",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4925",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3939",
      "sanitize-text": "/sanitize-text/static-1.7686",
      "signup-constants": "/signup-constants/static-1.17898",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.479",
      "usage-tracker": "/usage-tracker/static-1.6905",
      "usage-tracker-core": "/usage-tracker-core/static-1.6755",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5319",
      "usage-tracker-public": "/usage-tracker-public/static-1.6716",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5506",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3022",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.110",
      "quartz-core": "/quartz-core/static-1.5551",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4356",
      "foundations-theming": "/foundations-theming/static-1.3896",
      "UIComponents": "/UIComponents/static-3.7949",
      "cv-backend-services": "/cv-backend-services/static-1.1397",
      "immutable-less": "/immutable-less/static-1.4090",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6836",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31778",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1822",
      "icons": "/icons/static-2.599",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4188",
      "tanstack-virtual": "/tanstack-virtual/static-1.20",
      "ui-images": "/ui-images/static-2.1001",
      "permission-components": "/permission-components/static-1.4849",
      "react-virtualized": "/react-virtualized/static-2.87",
      "HeadJS": "/HeadJS/static-2.649",
      "framer-motion": "/framer-motion/static-1.58",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2589",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.140",
      "i18n-data": "/i18n-data/static-1.212",
      "moment-timezone": "/moment-timezone/static-5.73",
      "jasmine": "/jasmine/static-4.3807",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7585",
      "HubStyle": "/HubStyle/static-2.11310",
      "sassPrefix": "/sassPrefix/static-1.146",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3340",
      "floating-ui": "/floating-ui/static-1.46",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1612",
      "hs-story-utils": "/hs-story-utils/static-1.8898",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.772",
      "ui-fonts": "/ui-fonts/static-1.335",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3515",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5322",
      "bender-build-tools": "/bender-build-tools/static-1.2674",
      "dispatcher": "/dispatcher/static-1.126",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.727",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8901",
      "hubspotter-http": "/hubspotter-http/static-1.4219",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8899",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.422",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2379",
      "foundations-theming-base": "/foundations-theming-base/static-1.2881",
      "stylex": "/stylex/static-1.22",
      "ts-schema": "/ts-schema/static-1.3692",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2035",
      "content-assistance-lib": "/content-assistance-lib/static-1.7151",
      "crm-component-utils": "/crm-component-utils/static-1.37892",
      "crm-display-components": "/crm-display-components/static-1.23642",
      "crm-fe-perf": "/crm-fe-perf/static-1.22464",
      "crm-links": "/crm-links/static-1.5725",
      "crm-message-bus": "/crm-message-bus/static-1.41748",
      "crm-search-service-types": "/crm-search-service-types/static-1.779",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4802",
      "customer-data-communicator": "/customer-data-communicator/static-1.44284",
      "customer-data-email": "/customer-data-email/static-1.17186",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38079",
      "customer-data-objects": "/customer-data-objects/static-1.7177",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12528",
      "customer-data-properties": "/customer-data-properties/static-1.50072",
      "customer-data-rte": "/customer-data-rte/static-1.31878",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9299",
      "data-fetching-client": "/data-fetching-client/static-1.9207",
      "draft-plugins": "/draft-plugins/static-2.20816",
      "file-manager-components": "/file-manager-components/static-1.22194",
      "FileManagerCore": "/FileManagerCore/static-1.37693",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6434",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7488",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4346",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16987",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9530",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7580",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17215",
      "universal-associations-select": "/universal-associations-select/static-1.10513",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7694",
      "final-form": "/final-form/static-1.60",
      "graphql": "/graphql/static-1.72",
      "superstore": "/superstore/static-1.4268",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8295",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27297",
      "card-properties-lib": "/card-properties-lib/static-1.42896",
      "crm-actions": "/crm-actions/static-1.5728",
      "crm-cards-data": "/crm-cards-data/static-1.726",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42259",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8228",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7526",
      "customer-data-tracking": "/customer-data-tracking/static-1.6427",
      "usage-tracker-container": "/usage-tracker-container/static-1.6895",
      "framework-data-table": "/framework-data-table/static-2.10859",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7881",
      "calling-error-reporting": "/calling-error-reporting/static-1.30848",
      "calling-internal-common": "/calling-internal-common/static-1.30842",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6107",
      "crm_data": "/crm_data/static-4.90490",
      "crm_schema": "/crm_schema/static-3.90529",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23328",
      "customer-data-content": "/customer-data-content/static-1.26390",
      "draft-content-plugins": "/draft-content-plugins/static-1.27251",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23238",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22948",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23508",
      "FileManagerLib": "/FileManagerLib/static-1.37834",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16979",
      "integration-settings-components": "/integration-settings-components/static-1.14034",
      "integrations-lib": "/integrations-lib/static-1.14704",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5160",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7354",
      "nav-meta": "/nav-meta/static-1.28295",
      "onboarding-scopes": "/onboarding-scopes/static-1.6013",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5332",
      "property-translator": "/property-translator/static-1.4898",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36476",
      "react-colorpicker": "/react-colorpicker/static-2.9756",
      "react-dnd-compat": "/react-dnd-compat/static-1.4195",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7740",
      "rich-text-lib": "/rich-text-lib/static-1.18978",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3420",
      "sequences-lib": "/sequences-lib/static-1.7326",
      "timezone-utils": "/timezone-utils/static-2.4724",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10573",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8470",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8480",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9794",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9621",
      "user-context": "/user-context/static-1.4661",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4317",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4224",
      "salesImages": "/salesImages/static-1.515",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20513",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12593",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4203",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3563",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6339",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3248",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3481",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.540",
      "onboarding-tours": "/onboarding-tours/static-1.15949",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12320",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.177",
      "ui-addon-teams": "/ui-addon-teams/static-1.20919",
      "calling-global-api": "/calling-global-api/static-1.62953",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64335",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56629",
      "commerce-products-lib": "/commerce-products-lib/static-1.8131",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3422",
      "external-options-client-types": "/external-options-client-types/static-1.3641",
      "google-libphonenumber": "/google-libphonenumber/static-1.27",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2746",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3728",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.105",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3258",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47240",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3482",
      "property-value-citations": "/property-value-citations/static-1.686",
      "smart-property-lib": "/smart-property-lib/static-1.5030",
      "tiered-pricing": "/tiered-pricing/static-1.470",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10529",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3629",
      "video-components-external": "/video-components-external/static-1.9899",
      "video-data-lib": "/video-data-lib/static-1.33557",
      "audio-components": "/audio-components/static-1.5318",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35345",
      "video-components": "/video-components/static-1.11902",
      "video-embed": "/video-embed/static-1.34391",
      "batch-promise": "/batch-promise/static-1.1115",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3616",
      "persist-promise": "/persist-promise/static-1.3272",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24065",
      "knowledge-content-types": "/knowledge-content-types/static-1.8162",
      "payment-link-components": "/payment-link-components/static-1.22360",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9427",
      "call-summary": "/call-summary/static-1.37644",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9047",
      "feature-store-service-types": "/feature-store-service-types/static-1.4118",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4125",
      "merchandise-lib": "/merchandise-lib/static-1.248",
      "purchase-motions-components": "/purchase-motions-components/static-1.5062",
      "self-service-api": "/self-service-api/static-1.9746",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4109",
      "chatspot-client-types": "/chatspot-client-types/static-1.10221",
      "chatspot-core": "/chatspot-core/static-1.19497",
      "ContentUtils": "/ContentUtils/static-1.66968",
      "copilot-toolkit": "/copilot-toolkit/static-1.9887",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6062",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44752",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14148",
      "customer-data-associations": "/customer-data-associations/static-1.6795",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.552",
      "reporting-data": "/reporting-data/static-1.65607",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4333",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3255",
      "crm_universal": "/crm_universal/static-1.21348",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8454",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19908",
      "content-embed-lib": "/content-embed-lib/static-1.6913",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10827",
      "remote-ui": "/remote-ui/static-1.55",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5140",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15855",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2558",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12119",
      "laboratory-lib": "/laboratory-lib/static-3.6665",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9957",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8391",
      "messaging-types-lib": "/messaging-types-lib/static-1.44662",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15650",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7183",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4555",
      "magpie-lib": "/magpie-lib/static-1.5135",
      "navigation-messaging": "/navigation-messaging/static-1.5985",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17249",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16367",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7476",
      "growth-data-modal": "/growth-data-modal/static-1.4884",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2580",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.958",
      "navigation-components": "/navigation-components/static-1.16658",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4163",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.15",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7002",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10590",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34132",
      "products-iframe-lib": "/products-iframe-lib/static-1.6707",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9283",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4978",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8984",
      "fsm": "/fsm/static-1.3216",
      "policy-lib": "/policy-lib/static-1.6303",
      "react-tinymce": "/react-tinymce/static-1.53974",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53100",
      "tinymce-plugins": "/tinymce-plugins/static-1.56214",
      "tinymce-themes": "/tinymce-themes/static-1.55070",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10388",
      "content-media-compositions": "/content-media-compositions/static-2.14395",
      "idb-keyval": "/idb-keyval/static-1.34",
      "magpie-types": "/magpie-types/static-1.4595",
      "media-bridge-lib": "/media-bridge-lib/static-1.18188",
      "content-icons-ui": "/content-icons-ui/static-1.2055",
      "social-insights-client-types": "/social-insights-client-types/static-1.20779",
      "outpost": "/outpost/static-1.3815",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3182",
      "ui-addon-opt": "/ui-addon-opt/static-4.7970",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5347",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4660",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3194",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6906",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18814",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7516",
      "wootric-nps": "/wootric-nps/static-1.6438",
      "nav-client-types": "/nav-client-types/static-1.1808",
      "purchase-motions-api": "/purchase-motions-api/static-1.5064",
      "trials-service-types": "/trials-service-types/static-1.3526",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4225",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2527",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35889",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38278",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17837",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10395",
      "crm_components": "/crm_components/static-3.90490",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53311",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20375",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16415",
      "project-storage": "/project-storage/static-1.4196",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70389",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7401",
      "deal-intel-utils": "/deal-intel-utils/static-1.556",
      "reporting-client-types": "/reporting-client-types/static-1.2296",
      "react-flip-move": "/react-flip-move/static-1.60",
      "FireAlarmUi": "/FireAlarmUi/static-1.4124",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3779",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10379",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9004",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56589",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11431",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11365",
      "feedback-loader": "/feedback-loader/static-1.28359",
      "html-to-image": "/html-to-image/static-1.44",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6568",
      "property-management-iframe": "/property-management-iframe/static-1.11496",
      "reactflow": "/reactflow/static-1.51",
      "simple-data-table": "/simple-data-table/static-1.1513",
      "used-in-list-lib": "/used-in-list-lib/static-1.6423",
      "visual-association": "/visual-association/static-1.5351",
      "highcharts": "/highcharts/static-8.94",
      "reporting-visualizations": "/reporting-visualizations/static-1.57684",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3549",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2367",
      "ContentData": "/ContentData/static-1.67043",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.556",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1657",
      "reactive-lib": "/reactive-lib/static-1.265",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.102",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6290",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3580",
      "ui-tool-access": "/ui-tool-access/static-1.9655",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34357",
      "sales-views-client-types": "/sales-views-client-types/static-1.3811",
      "trellis-story-utils": "/trellis-story-utils/static-1.4053",
      "storybook-react": "/storybook-react/static-1.22",
      "hub-http-contrib": "/hub-http-contrib/static-1.2634",
      "interframe": "/interframe/static-3.4274",
      "tinymce-data": "/tinymce-data/static-1.39185",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4734",
      "codemirror": "/codemirror/static-5.85",
      "layout-dnd-components": "/layout-dnd-components/static-1.11604",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10579",
      "react-codemirror": "/react-codemirror/static-1.10174",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12868",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8704",
      "hls.js": "/hls.js/static-1.29",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8620",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6980",
      "chirp-fetch": "/chirp-fetch/static-1.1470",
      "copilot-plugins": "/copilot-plugins/static-1.9860",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2807",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17324",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35855",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9270",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4591",
      "utility-belt": "/utility-belt/static-1.2014",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21210",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79107",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6263",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53327",
      "commerce-products-api": "/commerce-products-api/static-1.1536",
      "SafeStorage": "/SafeStorage/static-1.3871",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55385",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101064",
      "reporting-ui-components": "/reporting-ui-components/static-2.62881",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14175",
      "association-translator": "/association-translator/static-1.2678",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7769",
      "settings-ui-nav": "/settings-ui-nav/static-2.9721",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19489",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1385",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5327",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3824",
      "property-management-common": "/property-management-common/static-1.3783",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14425",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11440",
      "ExportDialog": "/ExportDialog/static-6.9968",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32760",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8904",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12886",
      "highlight.js": "/highlight.js/static-1.69",
      "reporting-action-components": "/reporting-action-components/static-1.40089",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9113",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5052",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13657",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4561",
      "qrcode-generator": "/qrcode-generator/static-1.59",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.50",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16838",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6761",
      "products-ui-components": "/products-ui-components/static-1.38650",
      "totals-ui-components": "/totals-ui-components/static-1.22357",
      "reporting-plugins": "/reporting-plugins/static-1.9592",
      "reporting-reports": "/reporting-reports/static-1.65287",
      "reporting-snowflake": "/reporting-snowflake/static-1.54227",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14424",
      "simple-menus-lib": "/simple-menus-lib/static-1.15941",
      "academy-common-lib": "/academy-common-lib/static-1.12346",
      "dashboard-lib": "/dashboard-lib/static-1.79718",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8222",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9940",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15711",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18304",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7547",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.270",
      "property-description-translator": "/property-description-translator/static-1.3345",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3372",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7604",
      "academy-service-client": "/academy-service-client/static-1.3213",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3466",
      "oauth-service-types": "/oauth-service-types/static-1.3777",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};